import { useToaster } from '@anytag/graphql';
import { useLocation, useNavigate, useRouter } from '@tanstack/react-router';
import { TFunction, i18n } from 'i18next';
import { useTranslation } from 'react-i18next';


type LocationReturnType = ReturnType<typeof useLocation>;
export const useQueryHelper = (): {
  t: TFunction;
  i18n: i18n;
  router: ReturnType<typeof useRouter>;
  navigate: ReturnType<typeof useNavigate>;
  location: LocationReturnType;
  search: LocationReturnType['search'];
  pathname: LocationReturnType['pathname'];
  enqueueSnackbar: ReturnType<typeof useToaster>['enqueueSnackbar'];
  trimDotsFromMessage: (message: string) => string;
  goBack: () => void;
  invalidateRouteLoader: () => void;
} => {
  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useToaster();
  const location = useLocation();
  const navigate = useNavigate();
  const router = useRouter();
  const trimDotsFromMessage = (message: string) => (message ? message.replace(/\./g, '') : 'UnexpectedError');

  return {
    t,
    i18n,
    router,
    navigate,
    location, // Current search params
    ...location,
    enqueueSnackbar,
    trimDotsFromMessage,
    goBack: () => router.history.back(),
    invalidateRouteLoader: () => router.invalidate()
  };
};
